import { useEffect, useState } from 'react'
import { useUpdateSessionMutation } from 'src/app/appApiQueries'
import {selectSession} from 'src/app/session'
import { Session } from 'src/app/types'
import { useDebouncedCallback } from 'use-debounce'
import { useAppSelector } from './useRTK'
import { isEqual } from 'lodash'
import { selectStoredActiveSession } from 'src/app/hostSettings'

// This hook follows any changes made to the session within the redux store and debounces those changes before sending them off to the backend s3 bucket
export function useUpdateSession() {
  const session = useAppSelector(selectSession)
  const [updateSession] = useUpdateSessionMutation()
  const [debouncedSession, setDebouncedSession] = useState(session)
  const debouncedSessionFn = useDebouncedCallback((value: Session) => {
    setDebouncedSession(value)
  }, 1000)
  const storedActiveSession = useAppSelector(selectStoredActiveSession)
  const sessionsEq = isEqual(storedActiveSession, debouncedSession)

  // debounce session changes
  useEffect(() => {
    debouncedSessionFn(session)
  }, [session, debouncedSessionFn])

  // listen to the debounced changes before firing off mutation
  useEffect(() => {
    // only begin to send off updates if there is an id
    // id is added once a session is created in the backend
    if (debouncedSession.id && !sessionsEq && storedActiveSession) {
      updateSession({ session: debouncedSession })
    }
  }, [debouncedSession, sessionsEq, updateSession, storedActiveSession])
}

